import { createClient, type SupabaseClient } from "@supabase/supabase-js";

declare global {
  var __tkSupabaseClient: SupabaseClient | undefined;
}

const url = process.env.REACT_APP_SUPABASE_URL?.trim();
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim();

if (!url || !anon) {
  throw new Error(
    "Missing Supabase env vars: REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY must be set at build time."
  );
}

export const supabase =
  globalThis.__tkSupabaseClient ??
  (globalThis.__tkSupabaseClient = createClient(url, anon));
